import {
  faTag,
  faCamera,
  faChartPie,
  faBullhorn,
  faEdit,
  faClock,
  faBook,
} from '@fortawesome/free-solid-svg-icons';
import type { Suggestion, SidebarButton } from './types';

export const COLOR_MAP: Record<string, string> = {
  blue: '#1890ff',
  green: '#52c41a',
  purple: '#722ed1',
  orange: '#fa8c16',
  teal: '#13c2c2',
  red: '#ff4d4f',
  cyan: '#13c2c2',
  indigo: '#2f54eb',
  yellow: '#fadb14',
};

export const suggestions: Suggestion[] = [
  {
    id: 1,
    category: 'Growth',
    title: "Create a 'Buy 1, Get 1 Free' campaign",
    description:
      "Offers appear as a green tag on your cover image to help your store stand out. Merchants who create this offer often see up to 39% more orders.",
    actionText: 'Create campaign',
    icon: faTag,
  },
  {
    id: 2,
    category: 'Operations',
    title: 'Add photos to your items',
    description:
      'You have 10 items without photos. Adding pictures can increase sales by up to 23%.',
    actionText: 'Add photos',
    icon: faCamera,
    condition: (user) => user.itemsWithoutPhotos > 0,
  },
  {
    id: 3,
    category: 'Analytics',
    title: 'View detailed sales reports',
    description:
      'Get insights into your business performance with comprehensive analytics and reporting tools.',
    actionText: 'View reports',
    icon: faChartPie,
  },
];

export const getGreetingTime = (d: Date = new Date()): string => {
  const split_afternoon = 12;
  const split_evening = 17;
  const currentHour = d.getHours();

  if (currentHour >= split_afternoon && currentHour <= split_evening) {
    return 'afternoon';
  } else if (currentHour >= split_evening) {
    return 'evening';
  }
  return 'morning';
};

export const formatTimeAgo = (date: Date): string => {
  const now = new Date();
  const seconds = Math.round((now.getTime() - date.getTime()) / 1000);
  const minutes = Math.round(seconds / 60);
  const hours = Math.round(minutes / 60);
  const days = Math.round(hours / 24);

  if (seconds < 60) {
    return `${seconds} seconds ago`;
  } else if (minutes < 60) {
    return `${minutes} minutes ago`;
  } else if (hours < 24) {
    return `${hours} hours ago`;
  } else {
    return `${days} days ago`;
  }
};

export const PRIORITY_COLORS: Record<string, string> = {
  Growth: 'green',
  Operations: 'blue',
  Analytics: 'purple',
};

// Factory function to create sidebar buttons with action handler
export const createSidebarButtons = (showComingSoon: (feature: string) => void): SidebarButton[] => [
  {
    id: 1,
    text: 'Create ad',
    lefticon: faBullhorn,
    color: 'purple',
    description: 'Promote your store',
    action: () => showComingSoon('Create Ad'),
    disabled: false,
  },
  {
    id: 2,
    text: 'Create offer',
    lefticon: faTag,
    color: 'green',
    description: 'Boost sales',
    action: () => showComingSoon('Create Offer'),
    disabled: false,
  },
  {
    id: 3,
    text: 'Edit item',
    lefticon: faEdit,
    color: 'blue',
    description: 'Update menu',
    action: () => showComingSoon('Edit Item'),
    disabled: false,
  },
  {
    id: 4,
    text: 'Edit menu hours',
    lefticon: faClock,
    color: 'orange',
    description: 'Set availability',
    action: () => showComingSoon('Edit Menu Hours'),
    disabled: false,
  },
  {
    id: 5,
    text: 'Learning guide',
    lefticon: faBook,
    color: 'teal',
    description: 'Get help',
    action: () => showComingSoon('Learning Guide'),
    disabled: false,
  },
];
